import { render } from "./SelectManufactor.vue?vue&type=template&id=0f46d65a&scoped=true"
import script from "./SelectManufactor.vue?vue&type=script&lang=js"
export * from "./SelectManufactor.vue?vue&type=script&lang=js"

import "./SelectManufactor.vue?vue&type=style&index=0&id=0f46d65a&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f46d65a"]])

export default __exports__